import React, { useState, useRef } from "react";
import { Progress, Popover, PopoverBody, PopoverHeader } from "reactstrap";
import toTitleCase from '../Functions/toTitleCase';
import "./ProgressTrackingBar.css";

const ProgressTrackingBar = ({ progress, missingDataFields = [] }) => {
    const [popoverOpen, setPopoverOpen] = useState(false);
    const uniqueIdRef = useRef(Math.random().toString(36).substr(2, 9));
    const popoverTarget = `progressBar${uniqueIdRef.current}`;
    return (
        <div className="custom-progress-wrapper">
            <Progress value={progress} id={popoverTarget} onMouseEnter={() => setPopoverOpen(true)} onMouseLeave={() => setPopoverOpen(false)}>
                <p className="custom-progress-text mb-0" >{progress}%</p>
            </Progress>
            <Popover placement="right" isOpen={popoverOpen} target={popoverTarget}>
                <PopoverHeader><strong className='text-danger'>{missingDataFields?.length > 0 ? "Missing Fields" : ""}</strong></PopoverHeader>
                <PopoverBody>
                    {missingDataFields?.length > 0 ? (
                        <ul className='mb-0 pl-3'>
                            {missingDataFields.map((field, idx) => (
                                <li key={idx} style={{ marginBottom: 2 }}>{toTitleCase(field.replace(/_/g, ' '))}</li>
                            ))}
                        </ul>
                    ) : (
                        <strong className='text-success'><i className="fa fa-check-circle" style={{ marginRight: 6 }} />Completed</strong>
                    )}
                </PopoverBody>
            </Popover>
        </div>
    );
};

export default ProgressTrackingBar;